<template>
  <div class="home-message-update" @click="update">
    内容を更新
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [ MixinResultHandler ],
  methods: {
    update: async function () {
      const result = await this.$store.dispatch('app/save')
      this.showSnack(result)
    },
  },
}
</script>

<style lang="scss" scoped>
.home-message-update {
  @include button-ol-warning;
}
</style>
